export default (initialState = {}) => {
  return () => {
    return {
      billing_address: "",
      date: null,
      freight: 0,
      is_freight_included: true,
      lineitems: [
        {
          amount: "",
          amount_wt: "",
          conversion_factor: 1,
          cess: 0,
          gst: 0,
          hsn: 0,
          is_po_unit_bigger: false,
          is_tax_included: false,
          margin_expectation: null,
          name: "",
          po_amount: 0,
          po_qty: 0,
          po_rate: 0,
          po_unit: "",
          qty: "",
          rate: "",
          rate_wt: "",
          unit: "Unit",
          _id: null,
        },
      ],
      po_id: [],
      remarks: "",
      seller: null,
      shipping_address: "",
      tds: {},
      total_amount: 0,
      total_tax: 0,
      trade_type: "Non Smart",
      vehicle_number: "",
      ...initialState,
    };
  };
};
